import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq } = theme.custom;
    return {
        wrapper: { position: 'relative' },
        formContainer: { display: 'flex', flexDirection: 'column', gap: 20 },
        metaDataSection: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 12,
            alignItems: 'center',
            '& .MuiFormControl-root': { margin: '0 !important', minWidth: 0 },
        },
        mediaSection: { display: 'flex', flexDirection: 'column', gap: 16 },
        mediaRow: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 24,
            padding: '28px 20px 20px',
            border: `1px solid ${color.border}`,
            borderRadius: radius.md,
            position: 'relative',
            backgroundColor: color.surfaceMuted,
            [mq.sm]: { padding: '28px 12px 12px', gap: 16 },
        },
        sectionLabel: {
            position: 'absolute',
            top: -9,
            left: 14,
            padding: '0 8px',
            backgroundColor: color.surface,
            color: color.text.secondary,
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            borderRadius: 4,
        },
        buttonWrap: { display: 'flex', justifyContent: 'flex-end', gap: 8 },
        giftCardLoader: {
            width: '100%',
            height: '100%',
            backgroundColor: 'transparent',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 100,
        },
    };
});
